import { Box } from "@mui/material";
import { useState } from "react";

import AuthorizedTenantElement from "@/common/components/Auth/AuthorizedTenantElement";
import { GenericCalendarEntryOfScheduleEntryDto } from "@/common/mapping/mappers/scheduleEntry";
import { AppPermission, VehicleDto } from "@/core/api/generated/v1";

import AuthorizedElement from "../../Auth/AuthorizedElement";
import AppTab from "../../Tab/AppTab";
import AppTabs from "../../Tab/AppTabs";
import { CalendarProps, CalendarView, allCalendarViews } from "../Calendar";
import { VehicleActivityCalendar } from "./VehicleActivityCalendar";
import { VehicleStatusHistoryCalendar } from "./VehicleStatusHistoryCalendar";

const defaultCalendarProps: Partial<CalendarProps<GenericCalendarEntryOfScheduleEntryDto>> = {
  views: allCalendarViews,
  defaultView: CalendarView.Month,
  defaultDate: new Date(),
};

export const VehicleCalendarMode = {
  Activity: "Activity",
  StatusHistory: "StatusHistory",
} as const;
export type VehicleCalendarMode = (typeof VehicleCalendarMode)[keyof typeof VehicleCalendarMode];

interface Props {
  vehicle: VehicleDto;
}

export function VehicleCalendar({ vehicle }: Props) {
  const [mode, setMode] = useState<VehicleCalendarMode>(VehicleCalendarMode.Activity);

  const tabs = (
    <AppTabs
      value={mode}
      variant='scrollable'
      allowScrollButtonsMobile
      onChange={(e, value) => setMode(value as VehicleCalendarMode)}
    >
      <AppTab
        label='Activities'
        value={VehicleCalendarMode.Activity}
        disableRipple
        disableFocusRipple
        disableTouchRipple
      />
      <AppTab
        label='Status history'
        value={VehicleCalendarMode.StatusHistory}
        disableRipple
        disableFocusRipple
        disableTouchRipple
      />
    </AppTabs>
  );

  return (
    <AuthorizedElement permissions={[AppPermission.FleetAppAccess, AppPermission.VehicleRead]}>
      <AuthorizedTenantElement tenantIdsAny={[vehicle.tenantId, vehicle.ownerTenantId]} withAlert>
        <Box>
          {mode === VehicleCalendarMode.Activity && (
            <VehicleActivityCalendar
              vehicle={vehicle}
              tabs={tabs}
              calendarProps={defaultCalendarProps}
            />
          )}
          {mode === VehicleCalendarMode.StatusHistory && (
            <VehicleStatusHistoryCalendar
              vehicle={vehicle}
              tabs={tabs}
              calendarProps={defaultCalendarProps}
            />
          )}
        </Box>
      </AuthorizedTenantElement>
    </AuthorizedElement>
  );
}
